import { type VariationComponent, isCuratedLink } from "~types/types";
import type { IntegrityStatus } from "~utils/moduleIntegrity";

export default function integrityCheck({
    items,
}: VariationComponent): IntegrityStatus {
    const messages: IntegrityStatus = [];

    const isCuratedLinks = items.every((item) => isCuratedLink(item));

    if (!isCuratedLinks) {
        messages.push("Requires only CuratedLink type");
    }

    return messages;
}
